/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     Contacts
//   Details:    Contacts page
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 102715 16/08/19 JC       New
//-------------------------------------------------------
*/import React, { Component } from 'react';
import { connect } from 'react-redux';
import ItemsPage from '../components/ItemsPage';
import { itemCategories } from '../constants/ItemCategories';

class Contacts extends Component {
	render() {
		return (
            <ItemsPage
				title="Contacts"

				//unreadTabText="Unread"
				//readTabText="Read"

				unread={this.props.unread}
                //read={this.props.read}
                simpleMode={this.props.simpleMode} //need to pass in simple mode

				unreadItemTypes={this.props.unreadItemTypes}
				//readItemTypes={this.props.readItemTypes}

				unreadItemCategory={this.props.unreadItemCategory}
				//readItemCategory={this.props.readItemCategory}
			/>
		);
	}
}

export default connect(
	state => ({
        unread: state.allContacs,
        //read: state.allContacs,
        simpleMode: true,

		unreadItemTypes: state.allContactTypes,
        //readItemTypes: state.allContactTypes,

		unreadItemCategory: itemCategories.allContacts,
        //readItemCategory: itemCategories.allContacts
	})
)(Contacts);